import script from "./SideDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./SideDrawer.vue?vue&type=script&setup=true&lang=js"

import "./SideDrawer.vue?vue&type=style&index=0&id=e97d20c4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e97d20c4"]])

export default __exports__